
import { DashboardHeader } from "@/components/dashboard/DashboardHeader";
import { DashboardContent } from "@/components/dashboard/DashboardContent";

const Dashboard = () => {
  return (
    <div className="container py-8 space-y-8">
      <DashboardHeader />
      <DashboardContent />
    </div>
  );
};

export default Dashboard;
